import React from "react";
import "./HistoricalReproduction.scss";

const HistoricalReproduction = ({ title, description, image }) => {
  return (
    <section className="aboutSection">
      <div className="aboutSection__container">
        <div className="aboutSection__content">
          <h2>{title}</h2>
          <p className="aboutSection__description">{description}</p>
        </div>

        <div className="aboutSection__image">
          <img src={image} alt="about" />
        </div>
      </div>
    </section>
  );
};

export default HistoricalReproduction;
